/**
 * Megkeresi az oldalon a mutatható elemeket
 */

export default function (hints, elements) {
	var showableElements = [];
	for (var i = 0; i < hints.length; i++) {
		for (var j = 0; j < elements.length; j++) {
			if (hints[i].needToDisplay && hints[i].hintId == elements[j].getAttribute('hint-message') &&
				elements[j].getAttribute('hint-additional-logic') == 'true' && angular.element(elements[j]).is(':visible')) {
				showableElements.push(elements[j]);
				break;
			}
		}
	}
	return showableElements;

};
